// The value one non-date quick filter on the Enquiries list sends, from what its widget holds.
//
// Enquiries.vue renders a "Yes/No" field as a single-select Dropdown (the selection is one
// option object, { id, <field>: 'Yes' | 'No' }) and every other non-date field as a
// MultiSelect (an array of option objects). The inline code it replaces read `selection[field]`
// for YES/NO and "*" lists, which is undefined on an array, and skipped any selection without
// a `length`, which is every Dropdown object - so neither kind ever sent a value there.
//
// Everything else is exactly as before: a single option object still gives true/false for
// Yes/No and its own value for a "*" list; a string is sent as is; any other array is joined
// by the field's dbIdField. An empty array (an emptied MultiSelect) sends nothing.

function lastPart(dbField) {
  return String(dbField || '').split('.').slice(-1)[0]
}

function present(v) {
  return v !== undefined && v !== null && v !== ''
}

/** Whether the quick filter at this position holds a selection worth sending. */
export function hasQuickFilterSelection(field, selection) {
  if (selection && selection.length > 0) return true
  return !!(field && field.fieldType === 'Yes/No' && selection && typeof selection === 'object' && !Array.isArray(selection))
}

/**
 * The value to send for a non-date quick filter, or undefined for "send nothing".
 * YES/NO gives true or false (both or neither picked sends nothing); a "*" list gives its
 * picked values joined by commas.
 */
export function quickFilterValue(field, selection) {
  var b = lastPart(field && field.dbField)
  var lov = (field && field.lovEP) || ''

  if (Array.isArray(selection)) {
    // An emptied MultiSelect leaves [] behind: that is "nothing picked", not "" (the
    // backend rejects an empty filter value, and the Excel export would count the key)
    if (selection.length === 0) return undefined
    var picked = selection.map(function (item) { return item && item[b] }).filter(present)
    if (lov === 'YES/NO') {
      var distinct = picked.filter(function (v, i) { return picked.indexOf(v) === i })
      if (distinct.length !== 1) return undefined
      if (distinct[0] === 'Yes') return true
      if (distinct[0] === 'No') return false
      return undefined
    }
    if (lov.substr(0, 1) === '*') {
      return picked.length ? picked.join(',') : undefined
    }
    return selection.map(function (item) { return item[field.dbIdField] }).join(',')
  }

  if (selection === null || selection === undefined) return undefined
  if (selection[b] === 'Yes') return true
  if (selection[b] === 'No') return false
  if (lov.substr(0, 1) === '*') return selection[b]
  if (typeof selection === 'string') return selection
  return undefined
}
